/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/style.scss"

// Import Swiper styles globally (once) to avoid redundant imports in each component
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

// Import PrimeReact styles globally
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';

import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
// jQuery will be loaded from CDN in gatsby-ssr.js

export const wrapRootElement = ({ element }) => {
  return (
      <GoogleReCaptchaProvider 
        reCaptchaKey="6Lc5biIjAAAAAM72XJOuaCmVbyPh8s0b2gKWI_Aq"
        scriptProps={{
          async: true,
          defer: true,
          appendTo: "body",
        }}
        useReCaptchaNet={true}
        useEnterprise={false}
        language="en"
      >
          {element}
      </GoogleReCaptchaProvider>
  )
}

export const onRouteUpdate  = () => {
  if (typeof window === 'undefined') return
  if (window.jQuery) {
    const $ = window.jQuery
    initializeComponents($)
    return
  }

  const loadJQuery = () => new Promise((resolve) => {
    if (window.jQuery) return resolve(window.jQuery)
    const existing = document.querySelector('script[data-dynamic="jquery"]')
    if (existing) {
      existing.addEventListener('load', () => resolve(window.jQuery))
      return
    }
    const script = document.createElement('script')
    script.src = 'https://code.jquery.com/jquery-3.6.2.min.js'
    script.integrity = 'sha256-2krYZKh//PcchRtd+H+VyyQoZ/e3EcrkxhM8ycwASPA='
    script.crossOrigin = 'anonymous'
    script.async = true
    script.defer = true
    script.dataset.dynamic = 'jquery'
    script.addEventListener('load', () => resolve(window.jQuery))
    document.body.appendChild(script)
  })

  const triggerLoad = () => {
    ['mousedown','mousemove','keypress','scroll','touchstart'].forEach((evt) =>
      document.removeEventListener(evt, triggerLoad, listenerOpts)
    )
    loadJQuery().then(($) => initializeComponents($))
  }
  const listenerOpts = { once: true, passive: true }
  ;['mousedown','mousemove','keypress','scroll','touchstart'].forEach((evt) =>
    document.addEventListener(evt, triggerLoad, listenerOpts)
  )
  setTimeout(triggerLoad, 3000)
}

function initializeComponents($) {
  function initializeCustomCollapsible() {
    if ($(".custom-collapsible").length <= 0) return
    
    $(".custom-collapsible .collapsible-header").on("click", function (event) {
        event.preventDefault();
        var $body = $(this).next(".collapsible-body");
        if ($(this).hasClass("open")) {
            $(this).removeClass("open");
            $body.removeClass("open");
        } else {
            $(".collapsible-header").removeClass("open");
            $(".collapsible-body").removeClass("open");
            $(this).addClass("open");
            $body.addClass("open");
        }
    });
      
  }
  function initializeHeader() {
    $(".header-toggle-hamburger").on("click", function () {
      $(this).addClass("open")
      $(".header-toggle-cross").addClass("open")
      $(".mobile-menu-wrapper").addClass("open")
      $("body").addClass("mobile-lock")
    })
    $(".header-toggle-cross").on("click", function () {
      $(this).removeClass("open")
      $(".header-toggle-hamburger").removeClass("open")
      $(".mobile-menu-wrapper").removeClass("open")
      $("body").removeClass("mobile-lock")
    })

    $(".menu-item").on("click", function (e) {
      if ($(this).hasClass("custom-collapsible")) {
        $(this).find(".collapsible-body a").on("click", function () {
          $(".header-toggle-cross").removeClass("open")
          $(".header-toggle-hamburger").removeClass("open")
          $(".mobile-menu-wrapper").removeClass("open")
          $("body").removeClass("mobile-lock")
        })
        $(".menu-item .collapsible-header").on("click", function (e) {
          e.stopPropagation()
        })
      }else{
        $(".header-toggle-cross").removeClass("open")
        $(".header-toggle-hamburger").removeClass("open")
        $(".mobile-menu-wrapper").removeClass("open")
        $("body").removeClass("mobile-lock")
      }
    });
    
    if($("body").hasClass("mobile-lock")){
      $("body").removeClass("mobile-lock")
    }
  }

  function handleCustomTabs() {
    if ($(".tabs").length <= 0) return
    $(".tabs li").on("click", function () {
      if ($(this).hasClass("active")) return

      $(this).siblings().removeClass("active")
      const tabs = $(this).parents(".tabs").data("controls")
      $(tabs).children().removeClass("active")

      const target = $(this).data("tab")
      const title = $(this).parents(".tabs").data("title")
      if (title != null) $(title).text($(this).text())
      $(target).addClass("active")
      $(this).addClass("active")
    })
  }
  function initializeCustomCollapsiblefaq() {
    if ($(".custom-collapsible-faq").length <= 0) return
    $(".custom-collapsible-faq .collapsible-header-faq").on(
      "click",
      function () {
        const body = $(this).next(".collapsible-body-faq")
        const parent = $(this).parent(".custom-collapsible-faq")
        if (!$(this).hasClass("open")) {
          $(this).addClass("open")
          $(body).css("maxHeight", $(body)[0].scrollHeight + "px")
          if ($(parent).hasClass("accordian")) {
            $(parent)
              .siblings(".custom-collapsible-faq")
              .each(function (index, collapsible) {
                $(collapsible)
                  .find(".collapsible-body-faq")
                  .css("maxHeight", "0px")
                $(collapsible)
                  .find(".collapsible-header-faq")
                  .removeClass("open")
              })
          }
        } else {
          $(body).css("maxHeight", "0px")
          $(this).removeClass("open")
        }
      }
    )
    $(
      ".custom-collapsible-faq .collapsible-header-faq.open ~.collapsible-body-faq"
    ).each(function (index, body) {
      $(body).css("maxHeight", body.scrollHeight + "px")
    })
  }
  function initializeviewing() {
    if ($(".switch-wrapper").length <= 0) return
    $(".switch-wrapper").on("click", function () {
      if ($(".switch-wrapper").hasClass("active")) {
        $(".switch-wrapper").removeClass("active")
        $(".list-wrapper").removeClass("active")
        $(".map-wrapper").addClass("active")
        $(".map-view-text").addClass("active")
        $(".discover").removeClass("active")
        $(".list-view-text").removeClass("active")
      } else {
        $(".switch-wrapper").addClass("active")
        $(".list-wrapper").addClass("active")
        $(".map-wrapper").removeClass("active")
        $(".discover").addClass("active")
        $(".map-view-text").removeClass("active")
        $(".list-view-text").addClass("active")
      }
    })
  }
  $(document).ready(function () {
    initializeCustomCollapsible()
    initializeHeader()
    // initializeDropdown()
    handleCustomTabs()
    initializeCustomCollapsiblefaq()
    initializeviewing()
  })
}
